'use client'

import Link from 'next/link'

import SafeImage from '@/features/veluvit/components/ui/media-image'
import TagLine from '@/features/veluvit/components/ui/tag-line'
import WorkTitleOverlay from '@/features/veluvit/components/ui/work-title-overlay'

import type { Route } from 'next'
import type { SearchWork } from '@/features/veluvit/schemas/search.schema'

/** 검색 응답 한 건. 전체 카탈로그에 없는 작품도 서버 ID로 상세를 연다. */
export default function SearchResultCard({ work }: { work: SearchWork }) {
  const image = work.images?.thumb || work.image || work.images?.cover
  return (
    <Link
      href={`/c/${encodeURIComponent(work.id)}` as Route}
      className="group block min-w-0 no-underline focus-visible:underline"
    >
      <div className="relative aspect-[3/4] overflow-hidden rounded-panel bg-surface">
        {image && (
          <SafeImage
            src={image}
            alt=""
            fill
            sizes="(min-width: 1601px) 16vw, (min-width: 1001px) 22vw, 50vw"
            className="object-cover transition-transform duration-300 group-hover:scale-[1.03]"
            appearance="plain"
          />
        )}
        {!image && (
          <span
            aria-hidden="true"
            className="absolute inset-0 bg-foreground/[0.04]"
          />
        )}
        {image && (
          <WorkTitleOverlay
            src={work.titleImage || work.images?.logo}
            sizes="220px"
          />
        )}
      </div>
      <div className="pt-2.5">
        <span className="text-c12 font-semibold text-point over10:text-c13">
          {/* 1차는 캐릭터챗만 — 서버 kind 와 상관없이(backend9.md 1, live-catalog.ts charOf 와 같은 규칙) */}
          캐릭터
        </span>
        <h2 className="mt-0.5 line-clamp-2 text-c15 leading-[1.4] font-bold text-t1 group-hover:underline over10:text-c17">
          {work.name}
        </h2>
        {work.description && (
          <p className="mt-1 line-clamp-2 text-c12 leading-[1.5] text-t3 over10:text-c13">
            {work.description}
          </p>
        )}
        <TagLine tags={work.tags} max={3} size="md" />
        {work.creator?.name && (
          <p className="mt-1 truncate text-c12 text-t4 over10:text-c13">
            {work.creator.name}
          </p>
        )}
      </div>
    </Link>
  )
}
